/**
 * ── POR QUE AQUI NO HAY NINGUN DOMINIO ────────────────────────────────────
 *
 * `flogin` habla SOLO con su backend (ApiUserManager), y lo hace en el MISMO
 * ORIGEN: nginx sirve la SPA en `/` y enruta `/api`. Asi que `apiUrl` va vacio y
 * las llamadas salen relativas. En local lo simula `proxy.conf.json` contra
 * `localhost:9023`, o sea que desarrollo se comporta como el despliegue: sin
 * CORS y con cookies first-party.
 *
 * Hubo aqui un `BaseUrl` (gateway de la plataforma) y un `socketUrl`. Se
 * retiraron el 2026-09-18 al comprobar que tenian **cero usos**: su unico
 * consumidor era `documents-service`, que se fue con la limpieza. Llevaban
 * ademas un dominio escrito a mano, y esa es la segunda razon para no
 * devolverlos: un dominio que no se usa no puede estar bien, solo puede estar
 * viejo — y ahora mismo `sinay.com.mx` (lo que sirven los cinco frontends vivos)
 * y `sinay.mx` (lo que dicen los appsettings nuevos) conviven sin que este
 * resuelto cual gana.
 *
 * Si algun dia `flogin` necesita hablar con otro host, el dominio se toma de la
 * convencion viva —mirar `ffacturacion/src/environments/`— y no de memoria.
 */
/** Desarrollo. Es el que se edita para cambiar el comportamiento en local. */
export const environment = {
  production: false,
  apiUrl: '',
  /**
   * FALSE: desarrollo va contra ApiUserManager de verdad (9023, via el proxy).
   * Es el valor por defecto porque el backend ya corre en local.
   *
   * En `true` la app provee `AuthSimuladoService` y **no llama al backend en
   * ningun momento**: `demo/demo`, `uno/uno` y `nuevo/nuevo` viven dentro del
   * frontend. Sirve para trabajar la pantalla sin levantar la API, pero mientras
   * este puesto NO se puede entrar con un usuario real — y el sintoma es que las
   * credenciales buenas se rechazan, que no se parece a "estas en modo simulado".
   * La pantalla lo avisa: con el flag en true muestra las cuentas de prueba.
   */
  authSimulado: false,
};
